export const saleExpired = (validUntil: string | null | undefined) => {
    if (!validUntil) {
        return true;
    }

    const targetDateTime = new Date(validUntil);

    if (Number.isNaN(targetDateTime.getTime())) {
        return true;
    }

    return Date.now() > targetDateTime.getTime();
};
